import React, { useState, useEffect, useRef, useCallback } from 'react';
import Select from 'react-select';
import axios from "axios";
import Header from '../Header';
import Footer from '../Footer';
import FlashMessage from '../FlashMessage';
import 'datatables.net-bs5/css/dataTables.bootstrap5.min.css';
import $ from 'jquery';
import 'datatables.net-bs5';
import { Link } from 'react-router-dom';
import { format } from 'date-fns';
import CommonDatePicker from '../datepicker/CommonDatePicker';
import 'rsuite/dist/rsuite.min.css';
import { API_URL, BASE_URL } from '../Config';
import config from '../common/Config';
import PurchaseService from '../../services/PurchaseService';
import { setTableWidths, getTableWidths } from '../../data/postAPi';


const PurchasesHistory = () => {

	const [draw, setDraw] = useState(1);
	const [start, setStart] = useState(0);
	const [length, setLength] = useState(50);
	const [purchaseGrn, setPurchaseGrn] = useState([]);
	const [colWidths, setColWidths] = useState([100, 100, 100, 120, 180, 100, 120, 100]);
	const tableName = "purchaseHistoryTable";
	const userId = localStorage.getItem("userId");
	const debouncedSetTableWidths = useRef(
		(function debounce(func, wait) {
			let timeout;
			return function (...args) {
				clearTimeout(timeout);
				timeout = setTimeout(() => func.apply(this, args), wait);
			};
		})(setTableWidths, 500)
	).current;

	useEffect(() => {
		async function fetchWidths() {
			try {
				const res = await getTableWidths(userId, tableName);
				if (res?.data?.widths && Array.isArray(res.data.widths) && res.data.widths.length > 0) {
					setColWidths(res.data.widths);
				}
			} catch (e) {}
		}
		fetchWidths();
	}, []);

	const startResizing = (index, e) => {
		e.preventDefault();
		const startX = e.clientX;
		const startWidth = colWidths[index];
		const onMouseMove = (moveEvent) => {
			const newWidth = Math.max(50, startWidth + moveEvent.clientX - startX);
			setColWidths((widths) => {
				const updated = [...widths];
				updated[index] = newWidth;
				debouncedSetTableWidths(userId, tableName, updated);
				return updated;
			});
		};
		const onMouseUp = () => {
			document.removeEventListener("mousemove", onMouseMove);
			document.removeEventListener("mouseup", onMouseUp);
		};
		document.addEventListener("mousemove", onMouseMove);
		document.addEventListener("mouseup", onMouseUp);
	};
	useEffect(() => {
		const styleSheet = document.createElement('style');
		styleSheet.textContent = `.th-resizer:hover {background-color: rgba(0,0,0,0.3)!important;} .resizable-header {position:relative;user-select:none;}`;
		document.head.appendChild(styleSheet);
		return () => {
			if (document.head.contains(styleSheet)) {
				document.head.removeChild(styleSheet);
			}
		};
	}, []);
	const addResizerListeners = () => {
		const resizers = document.querySelectorAll(`.purchase-history .th-resizer`);
		resizers.forEach((resizer, index) => {
			const handler = (e) => {
				startResizing(index, e);
			};
			resizer.addEventListener('mousedown', handler);
			resizer._resizerHandler = handler;
		});
	};
	useEffect(() => {
		setTimeout(() => {
			addResizerListeners();
			const ths = document.querySelectorAll(`.purchase-history thead th`);
			ths.forEach((th, idx) => {
				th.style.width = colWidths[idx] + 'px';
			});
		}, 200);
	}, [purchaseGrn]);

	const accessToken = localStorage.getItem('accessToken');
	const company_tax_type = localStorage.getItem("company_tax_type");
	const fetchPurchaseGrnList = async () => {
		const params = new URLSearchParams();
		params.append('draw', draw);
		params.append('start', start);
		params.append('length', length);

		const apiPurchaseOrderUrl = `${API_URL}/purchase/purchaseHistory?${params.toString()}`;
		try {
			const response = await fetch(apiPurchaseOrderUrl, {
				method: 'GET',
				headers: {
					authorization: `Bearer ${accessToken}`,
				},
			});

			if (!response.ok) {
				throw new Error('Failed to fetch purchase order');
			}
			const data = await response.json();
			setPurchaseGrn(data.data);
			//console.log(data);

		} catch (error) {
			console.error('api Error fetching purchase order:', error);
		}
	};

	/*useEffect(() => {

			if (accessToken === null){
			window.location.href = `${config.BASE_URL}/login`; 
			return;
		}
	    
		fetchPurchaseGrnList();
		},[]);*/

	useEffect(() => {
		if (accessToken === null) {
			window.location.href = `${config.BASE_URL}/login`;
			return;
		}
		const loadPurchaseGrnList = async () => {
			try {
				const data = await PurchaseService.fetchPurchaseGrnList(draw, start, length, accessToken);
				setPurchaseGrn(data);
			} catch (error) {
				console.error('Failed to load purchase GRN list:', error);
			}
		};

		loadPurchaseGrnList();
	}, [draw, start, length, accessToken]);

	useEffect(() => {
		// Initialize DataTable
		const table = $('#purchaseGrnTable').DataTable({
			pageLength: 50,
			paging: true,
			lengthMenu: [10, 20, 50],
			searching: true,
			ordering: false,
			info: true,
			responsive: true,
			autoWidth: false,
			language: {
				paginate: {
					first: 'First',
					last: 'Last',
					next: 'Next',
					previous: 'Previous',
				},
				search: 'Search:',
			},
			data: purchaseGrn,
			columns: [
				{ data: 'date', width: '8%' },
				{ data: 'Po', width: '8%' },
				{ data: 'Grn', width: '8%' },
				{ data: 'invoice_number', width: '9%' },
				{ data: 'supplier' },
				{ data: 'total_tax', width: '6%' },
				{ data: 'grand_total', width: '8%' },
				{
					data: null,
					width: '5%',
					className: 'text-center',
					render: function (data, type, row) {
						return '<a class="icon viewbtn" title="View" href="' + config.BASE_URL + '/purchases/view_grn/' + row.id + '"  id="mark_deliver">  <i class="fa fa-eye"></i></a>';
					}
				}
			],
			drawCallback: function (settings) {
			}
		});



		return () => {
			table.destroy();
		};
	}, [purchaseGrn]);

	return (
		<>
			<Header />
			<div className="breadcrumbs">
				<div className="container-fluid">
					<div className="row">
						<div className="col-12 col-lg-12 col-sm-12">
							<Link to="/Dashboard"><i className="fa fa-home"></i></Link>
							<Link to="/reports/mis_report">Purchases</Link>
							<Link to="/reports/mis_report">Purchases GRN</Link>
						</div>
					</div>
				</div>
			</div>
			<div className="main-container">
				<div className="container-fluid">

					<div className="total-manifests-area dashboard" style={{ position: 'relative' }} >
						<p><b>GRN </b></p>

						<div className="verical-scrl-wrapper common-table autoheight-table purchase-history" id="style-3">
							<table className="table table-bordered dataTable resizable" id="purchaseGrnTable">
								<thead>
									<tr>
										{["Date", "PO No", "Grn No", "Supplier Inv No", "Supplier", company_tax_type, "Grand Total", "Action"].map((header, idx) => (
											<th
												key={header}
												className="resizable-header"
												style={{ width: colWidths[idx], minWidth: 50, position: "relative", padding: "8px" }}
											>
												{header}
												{idx < colWidths.length - 1 && (
													<div
														className="th-resizer"
														data-column-index={idx}
														title="Drag to resize column"
														style={{ position: 'absolute', right: '-2px', top: 0, width: '5px', height: '100%', cursor: 'col-resize', zIndex: 999, userSelect: 'none' }}
													/>
												)}
											</th>
										))}
									</tr>
								</thead>
								<tbody>

								</tbody>
								<tfoot>

								</tfoot>
							</table>
						</div>
					</div>

				</div>
			</div>
			<Footer />

		</>
	);

}
export default PurchasesHistory;